import React from 'react';
import { Helmet } from "react-helmet";
import axios from 'axios';
import { Skeleton } from 'antd';
import { matchPath } from "react-router-dom";
import { Symptom } from './symptom';
import './symptom.style';
import { getPostsSEO } from '../../API/seo';
import { Error404_Component } from "../errors/404";

export class Symptom_Component extends React.Component {
    constructor( props ) {

        super();

        if( props.staticContext ) {
            this.state = {
                isLoading: false,
                title: props.staticContext.title,
                description: props.staticContext.description,
                error_code: props.staticContext.error_code,
            };
        } else if( window.initial_state ) {
            this.state = {
                isLoading: false,
                title: window.initial_state.title,
                description: window.initial_state.description,
                error_code: window.initial_state.error_code,
            };
        } else {
            this.state = {
                isLoading: true,
                title: '',
                description: '',
                error_code: 200,
            };
        }
    }

    static async fetchData(url) {
        let category = url.split('/').slice(1)[0];
        let id = url.split('/').slice(1)[1];
        return getPostsSEO({
            id: id,
            category: category
        }).then(async response => {
            return {
                title: response?.result?.seo_title,
                description: response?.result?.seo_description,
                error_code: response?.result?.error_code
            };
        } );
    }

    componentDidMount() {;
        if( this.state.isLoading ) {
            Symptom_Component.fetchData(this.props.match.url).then( data => {
                this.setState( {
                    isLoading: false,
                    title: data.title,
                    description: data.description,
                    error_code: data.error_code,
                } );
            } );
        }
    }

    render() {
        return (
            this.state.isLoading ? 
                <section className='container shadow default_padding marginTop'>
                    <div className='content'>
                        <Skeleton active />
                    </div>
                </section>
            :
                <>
                    <Helmet>
                        <title>{ this.state.title } - Медицинский портал Нижегородской области: информация о врачах и учреждениях здравоохранения</title>
                        <meta property='og:title' content={`${ this.state.title } - Медицинский портал Нижегородской области: информация о врачах и учреждениях здравоохранения`} />
                        <meta name="description" content={`${ this.state.description !== null ? this.state.description : '' }`} />
                        <meta name="og:description" content={`${ this.state.description !== null ? this.state.description : '' }`} />
                        <meta name="keywords" content={`${ this.state.seo_keywords !== null ? this.state.seo_keywords : '' }`} />
                    </Helmet>
                    <Symptom />
                </>
        );
    }
}